import { render, staticRenderFns } from "./transaction-formula-detail.html?vue&type=template&id=e510040a&scoped=true&external"
import script from "./transaction-formula-detail.js?vue&type=script&lang=js&external"
export * from "./transaction-formula-detail.js?vue&type=script&lang=js&external"
import style0 from "./transaction-formula-detail.scss?vue&type=style&index=0&id=e510040a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e510040a",
  null
  
)

export default component.exports